<template>
    <div class="up-for-time mt-4 mx-5 fs-14px">
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tài khoản có:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{money.money_text}}</span> {{money.unit}}</span>
                <span class="ml-3"><a href="https://vatgia.com/nap-tien.html" class="btn-recharge">Nạp {{money.unit}}</a></span>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Số lần up {{product.length > 1 ? 'mỗi tin' : ''}}:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'mt-2': $detect == 'mobile'
            }">
                <input type="text" inputmode="numeric" class="input-number-up" v-model="count"
                    @input="calculateTotal" @focus="(e) => e.target.select()">
                {{config.con_product_auto_up_price ? config.con_product_auto_up_price.unit : ''}}
                <span class="mx-1" v-if="product.length > 1">x 3</span>
                <span class="mx-1">=</span>
                <input type="text" inputmode="numeric" class="input-price-up ml-1" v-model="total"
                    @input="calculateCount" @focus="(e) => e.target.select()"/> {{money.unit}}
                <p class="mb-0 text-secondary fs-12px mt-2">* Tối đa 10.000 lần hoặc {{$formatNumber(product.length * 10000 * (config.con_product_auto_up_price ? config.con_product_auto_up_price.money : 0))}} {{money.unit}}</p>
            </div>
        </div>
        <div :class="{
                'time-to-time mt-4': true,
                'time-to-time d-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30 title-time-up': $detect == 'web'
                }">
                Khoảng thời gian up:</div>
            <div :class="{
                'input-time-to-time mt-2': true,
                'w-70': $detect == 'web'
            }">
                <div class="d-flex">
                    <div class="item">
                        <ldc-time placeholder="HH:mm"
                            :showSeconds="false"
                            :jumpMinutes="5"
                            v-model="time_min"/>
                    </div>
                    <div class="mx-2 mt-1">-</div>
                    <div class="item">
                        <ldc-time placeholder="HH:mm"
                            :showSeconds="false"
                            :jumpMinutes="5"
                            v-model="time_max"/>
                    </div>
                </div>
                <p class="mb-0 text-secondary fs-12px mt-2">* Up tự động sẽ mặc định thực thi từ 8h đến 22h hàng ngày.</p>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">
                Mỗi {{config.con_product_auto_up_price ? config.con_product_auto_up_price.unit : ''}} cách nhau:
            </div>
            <div :class="{
                'w-70': $detect == 'web'
            }">
                <ldc-select-show-option
                    class="item-time-up"
                    v-model="space_time"
                    :showPlaceholder="false">
                    <ldc-option-show
                        role="button"
                        v-for="(time, index) in times" :key="index"
                        :value="time.value"
                        :label="time.label"/>
                </ldc-select-show-option>
            </div>
        </div>
        <div class="mt-5 mt-mobile">
            <p class="text-center mb-0 text-danger mb-2 fs-14px"
                v-if="$stringToNumber(total) > money.money">
                Quá số điểm trong tài khoản, Vui lòng nạp thêm {{money.unit}}
            </p>
            <div class="btn-confirm mb-3">
                <button class="btn btn-primary mx-auto py-1"
                    @click="submit()"
                    :disabled="$stringToNumber(total) > money.money || loading || count <= 0 || count > 10000">Thực hiện</button>
            </div>
        </div>
    </div>
</template>
<script>
import { getMinutes } from '@/config/function';
export default {
    props: ['product', 'price'],
    data() {
        return {
            times: [
                {
                    value: 3,
                    label: '3 phút'
                },
                {
                    value: 5,
                    label: '5 phút'
                },
                {
                    value: 10,
                    label: '10 phút'
                },
                {
                    value: 15,
                    label: '15 phút'
                },
                {
                    value: 30,
                    label: '30 phút'
                },
                {
                    value: 60,
                    label: '1 giờ'
                },
                {
                    value: 90,
                    label: '1,5 giờ'
                },
                {
                    value: 120,
                    label: '2 giờ'
                },
                {
                    value: 180,
                    label: '3 giờ'
                },
                {
                    value: 300,
                    label: '5 giờ'
                },
            ],
            time_min: '08:00',
            time_max: '22:00',
            space_time: '',
            total: 0,
            numberUp: '',
            loading: false,
            count: 1,
        }
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    watch: {
        product: {
            handler(val){
                this.calculateCount();
            },
            deep: true,
        },
        price(val){
            this.total = formatNumber(val);
            this.calculateCount();
        },
        total(val){
            this.$emit('update:price', stringToNumber(val))
        },
    },
    created() {
        this.$eventBus.$on('reset-auto-up', data => {
            if(data) this.reset();
        });
        this.total = formatNumber(this.price)
    },
    methods: {
        calculateTotal(){
            let check = stringToNumber(this.count);
            if(check > 0 && check <= 10000){
                this.count = formatNumber(check);
            }else{
                if(check <= 0){
                    this.count = '1';
                }else{
                    this.count = formatNumber(10000);
                }
            }
            this.total = formatNumber(this.product.length * stringToNumber(this.count) * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_PRO_UP_PRICE', true)));
        },
        calculateCount(){
            let check = stringToNumber(this.total);
            if(check >= 0 && check <= 10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_PRO_UP_PRICE', true))){
                this.count = formatNumber(Math.floor(stringToNumber(this.total) / (this.product.length * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_PRO_UP_PRICE', true)))))
                this.total = formatNumber(check);
            }else{
                if(check < 0){
                    this.count = '1';
                    this.total = 1 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_PRO_UP_PRICE', true));
                }else{
                    this.total = formatNumber(10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_PRO_UP_PRICE', true)) * this.product.length);
                    this.count = formatNumber(10000)
                }
            }
        },
        async submit(){
            if(this.price > this.money.money){
                this.$message({
                    message: `Vượt quá số ${this.money.unit} có trong tài khoản, Vui lòng nạp ${this.money.unit}`,
                    type: 'warning',
                    center: true,
                });
                return;
            }else if(this.count > 10000){
                this.$message({
                    message: 'Vượt quá 10.000 lượt up, vui lòng điều chỉnh lại',
                    type: 'warning',
                    center: true,
                });
                return;
            }else if(this.count <= 0){
                this.$message({
                    message: 'Vui lòng nhập số lượt up (số lượt up là 1 số dương)',
                    type: 'warning',
                    center: true,
                });
                return;
            }else if(this.space_time === ''){
                this.$message({
                    message: 'Vui lòng chọn khoảng thời gian up',
                    type: 'warning',
                    center: true,
                });
                return;
            }
            this.loading = true;
            this.postData()
            this.reset();
            this.$eventBus.$emit('reset-auto-up', true);
            getMoney();
            this.loading = false;
        },
        reset(){
            this.time_min = '08:00';
            this.time_max = '22:00';
            this.space_time = '';
            this.numberUp = '';
        },
        async postData(id){
            let data = {
                id: this.$route.query.id,
                type: 0,
                time_min: this.time_min === '' ? '' : getMinutes(this.time_min),
                time_max: this.time_max === '' ? '' : getMinutes(this.time_max),
                quantity: stringToNumber(this.count),
                schedule_time: this.space_time,
            }
            apiPost('/v2/profile/product/schedule_auto_up', data).then(res => {
               if(res.success == 1){
                    this.$message({
                        message: `Đặt lịch up tự động thành công cho id: ${this.$route.query.id}`,
                        type: 'success',
                        center: true,
                    })
                    this.$eventBus.$emit('call-history-auto-up', this.$route.query.id);
                    location.reload();
                }
                this.$eventBus.$emit('call-history-auto-up', this.$route.query.id);
            }).catch(err => {
                if(err.status == 500){
                    this.$message({
                        message: `Lỗi hệ thống vui lòng thực hiện lại`,
                        type: 'error',
                        center: true,
                    })
                }
            });
        }
    }
}
</script>
<style lang="scss">
.auto-up-rv-web {
    .up-for-time {
        .w-30 {
            width: 30%;
        }
        .w-70 {
            width: 70%;
            .input-number-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 50px;
                border-radius: 0 !important;
                &:focus {
                    outline: none;
                }
            }
            .item-time-up {
                margin-top: -8px;
                padding: 0 !important;
                .option {
                    border-radius: 4px !important;
                    width: 85px;
                    padding: 5px 0 !important;
                    text-align: center;
                }
                .bg-primary {
                    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
                }
            }
            .text-warning-up {
                color: rgba(0, 0, 0, 0.5);
            }
            .btn-recharge {
                text-decoration: underline;
            }
            .input-price-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 75px;
                border-radius: 0 !important;
                color: #dc3545;
                font-weight: 600;
                &:focus {
                    outline: none;
                }
            }
        }
        .time-to-time {
            .item {
                input {
                    width: 100px;
                }
            }
        }
        .btn-confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            button {
                padding-left: 40px;
                padding-right: 40px;
            }
        }
        .title-time-up {
            line-height: 45px;
        }
    }
}
.auto-up-rv-mobile {
    .up-for-time {
        margin: 0 !important;
        margin: 24px 0 0 0 !important;
        .w-30 {
            width: 40%;
            font-size: 14px;
        }
        .w-70 {
            width: 60%;
            font-size: 14px;
            .ldc-input-select {
                input {
                    height: 35px !important;
                }
            }
        }
        .btn-recharge {
            text-decoration: underline;
        }
        .input-number-up {
            border: none;
            border-bottom: 1px solid #000;
            width: 35px;
            border-radius: 0 !important;
        }
        .input-price-up {
            border: none;
            border-bottom: 1px solid #000;
            width: 75px;
            font-weight: 600;
            color: #dc3545;
        }
        .item-time-up {
            padding: 0 !important;
            .option {
                width: calc( 25% - 8px) !important;
                padding: 8px 0 !important;
                border-radius: 4px !important;
                text-align: center !important;
                &:nth-child(4n-4) {
                    margin-right: 0 !important;
                }
            }
            .bg-primary {
                box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
            }
        }
        .text-warning-up {
            color: rgba(0, 0, 0, 0.5);
            display: block;
            margin-left: 0 !important;
            margin-top: 5px !important;
        }
    }
    .mt-mobile {
        margin-top: 24px !important;
    }
    .btn-confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        button {
            padding-left: 40px;
            padding-right: 40px;
        }
    }
    .recharge-mobile {
        display: block;
        margin: 0 !important;
    }
}
</style>
